import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './table-cell.styl'

const Cell = ({ children, head, intlKey }) => {
  const Component = head ? 'th' : 'td'
  const classes = [styles.cell, head && styles.head].join(' ')
  const isIntl = typeof children === 'string' && intlKey

  return (
    <Component className={classes}>
      {isIntl
        ? <FormattedMessage id={intlKey} defaultMessage={children} />
        : children}
    </Component>
  )
}

Cell.propTypes = {
  children: PropTypes.any,
  head: PropTypes.bool,
  intlKey: PropTypes.string
}
Cell.displayName = 'TableCell'

export default Cell
